export default __webpack_public_path__ + "static/media/spiritualwrack.a836f0a3.png";